import { render } from "./PlanRmrpSummary.vue?vue&type=template&id=2eba47ad&ts=true"
import script from "./PlanRmrpSummary.vue?vue&type=script&lang=ts"
export * from "./PlanRmrpSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__